import { CREHANA_DOMAIN_PRD } from '@crehana/constants';

/**
 * Matches emails
 */
export const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Accepts numbers only
 */
export const NUMBERS_ONLY = /^[0-9]+$/;

/**
 * Matches:
 * - dd/mm/yyyy
 * - dd-mm-yyyy
 * - dd.mm.yyyy
 */
export const DATE =
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{4})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/;

export const COMPANY_SIZE_OPTIONS = [
  { value: 'SIZE_MAX_250', label: 'FORM_COMPANY_SIZE_150' },
  { value: 'SIZE_MAX_1000', label: 'FORM_COMPANY_SIZE_MORE_150' },
  { value: 'SIZE_MORE_THAN_1000', label: 'FORM_COMPANY_SIZE_MORE_1000' },
  { value: 'SIZE_MORE_THAN_5000', label: 'FORM_COMPANY_SIZE_MORE_5000' },
];

export const COUNTRIES = [
  { value: 'AR', label: 'Argentina' },
  { value: 'BZ', label: 'Belice' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BR', label: 'Brasil' },
  { value: 'CL', label: 'Chile' },
  { value: 'CO', label: 'Colombia' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CB', label: 'Cuba' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'ES', label: 'España' },
  { value: 'US', label: 'Estados Unidos de América' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'HN', label: 'Honduras' },
  { value: 'MX', label: 'México' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'PA', label: 'Panamá' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Perú' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'DO', label: 'República Dominicana' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'VE', label: 'Venezuela' },
  { value: '*', label: 'Otros' },
];

export const baseRedirectUrlToDownloadableForm = `https://empresas.${CREHANA_DOMAIN_PRD}/descargables`;

export const baseRedirectUrlToContactForm = `https://empresas.${CREHANA_DOMAIN_PRD}/contactanos`;
